import { styled } from '@mui/material'

import { Button } from '@collaborate-health/uikit'

export const FormActionButton = styled(Button)({
  minWidth: 0,
})

